module.exports = __webpack_public_path__ + "img/work2.21902404.gif";